import React from 'react';
import CardSlider from "../card_slider/card_slider";
import RecentlyViewed from "./recently_viewed";
import ReactDOM from "react-dom/client";
import Saved from "../saved/saved";

const RecentlyViewedInit = () => {

  const cookieName = 'naco_recently_viewed';

  const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=')
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
  }

  let currentCookies = getCookie(cookieName);
  if (!currentCookies) {
    return;
  }

  currentCookies = JSON.parse(currentCookies);

  currentCookies.reverse();

  const domEls = document.querySelectorAll('.card-slider.recently-viewed');
  if (domEls.length) {
    for (const el of domEls) {
      RecentlyViewed(el, currentCookies)
        .then((el) => {
          setTimeout(() => { CardSlider(el); }, 100);
          return el;
        })
        .then((el) => {
          setTimeout(() => {
            const saveEls = el.querySelectorAll('.card__toggle-save');
            saveEls.forEach(saveEl => {
              let root = ReactDOM.createRoot(saveEl);
              root.render(<Saved api={saveEl.dataset.api} user={saveEl.dataset.user} hasSaved={saveEl.dataset.saved} title={saveEl.dataset.title} />);
            });
          }, 100);
        })
      ;
    }
  }
}

export default RecentlyViewedInit;
